/* eslint-disable @typescript-eslint/no-explicit-any */
import './index.scss';
import { useMediaQuery } from '@mui/material';
import { useRef, useState } from 'react';
import { MVPFormData } from '../advanta-mvp-charts/constants';
import {
  ArrowDropDown,
  ArrowDropUp,
  FilterAltOutlined,
} from '@mui/icons-material';

import { ReactComponent as HomeIcon } from '../../assets/icons/homeIcon.svg';
import { ReactComponent as ReportsIcon } from '../../assets/icons/reportsIcon.svg';
import { ReactComponent as InsightIcon } from '../../assets/icons/insightIcon.svg';
import { ReactComponent as SettingIcon } from '../../assets/icons/settingsIcon.svg';

import React from 'react';

import {
  Box,
  AppBar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
} from '@mui/material';

import { ScatterplotChart } from '../advanta-mvp-charts/charts/scatterplotChart';
import { MVPReports } from '../advanta-mvp-charts/reports';
import { MVPFilters } from '../advanta-mvp-charts/filters';
import { MVPDataTable } from '../advanta-mvp-charts/charts/table/DataTable';
import { TimeSeriesTiles } from '../advanta-mvp-charts/timeSeriesTiles';
import { MVPArchieved } from '../advanta-mvp-charts/archieved';
import MVPAppHeader from '../../components/mvpHeader';
import { MapView } from '../advanta-mvp-charts/map';

import { UserManagement } from '../admin-ui/pages/userManagement';

import { FieldManagement } from '../admin-ui/pages/fieldManagement';

import { MaterialManagement } from '../admin-ui/pages/materialManagement';
import { AdminUI } from '../admin-ui';
import { GrowthManagement } from '../admin-ui/pages/growthManagement';
import { OrganizerManagement } from '../admin-ui/pages/organizerManagement';
import { ImportHistory } from '../admin-ui/pages/importHistory';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { GeographyManagement } from '../admin-ui/pages/geographyManagement';

//const drawerWidth = 360;
type MVPFiltersProps = {
  filtersIsCollapsed: boolean;
  handleApplyFilter: (values: MVPFormData) => void;
  filterValues: MVPFormData;
};

export const MVPSidebar: React.FC<MVPFiltersProps> = ({
  filtersIsCollapsed,
  handleApplyFilter,
  filterValues: commonFilters,
}) => {
  const isMobileView: boolean = useMediaQuery(
    '(max-width:1024px)'
  );
  const headerRef = useRef<HTMLElement | null>(null);

  const isSticky = false;

  const [showFilterBottomSheet, setShowFilterBottomSheet] =
    useState<boolean>(false);

  const [navigationState, setNavigationState] = useState<{
    tabId: string;
    props?: any;
  }>({
    tabId: 'insights',
    props: {},
  });

  const [navigationStack, setNavigationStack] = useState<
    string[]
  >(['insights']);
  console.log(navigationStack);
  const handleNavigation = (tabId: string, props?: any) => {
    setNavigationState({ tabId, props });
    setNavigationStack((prev) => [...prev, tabId]);
  };
  // Add a back handler
  const handleBackNavigation = () => {
    setNavigationStack((prev) => {
      if (prev.length > 1) {
        const newStack = prev.slice(0, -1);
        const previousTab = newStack[newStack.length - 1];
        setNavigationState({ tabId: previousTab });
        return newStack;
      }
      return prev;
    });
  };
  const user = useSelector(
    (state: RootState) => state.authUser
  );
  const menuItems = [
    { id: 'insights', label: 'Insights', icon: HomeIcon },
    {
      id: 'allfields',
      label: 'All Fields',
      icon: InsightIcon,
    },
    { id: 'reports', label: 'Reports', icon: ReportsIcon },
    {
      id: 'settings',
      label: 'Settings',
      icon: SettingIcon,
      allowedRoles: ['ADMIN', 'SUPER_ADMIN'],
    },
  ];

  const visibleMenuItems = menuItems.filter((item) => {
    if (!item.allowedRoles) return true;
    return item.allowedRoles.includes(user?.role);
  });

  const renderContent = () => {
    switch (navigationState.tabId) {
      case 'insights':
        return (
          <ScatterplotChart
            handleApplyFilter={handleApplyFilter}
            onNavigate={handleNavigation}
          />
        );
      case 'allfields':
        return (
          <MVPDataTable
            // filtersIsCollapsed={filtersIsCollapsed}
            handleApplyFilter={handleApplyFilter}
            onNavigate={handleNavigation}
          />
        );
      case 'reports':
        return <MVPReports onNavigate={handleNavigation} />;
      case 'timeseries':
        return (
          <TimeSeriesTiles
            {...navigationState.props}
            onBack={handleBackNavigation}
          />
        );
      case 'archievedReports':
        return (
          <MVPArchieved
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      case 'comparative':
        return (
          <MapView
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      case 'settings':
        return <AdminUI onNavigate={handleNavigation} />;
      case 'userManagement':
        return (
          <UserManagement
            filterValues={commonFilters}
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      case 'growthManagement':
        return (
          <GrowthManagement
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      case 'geographyManagement':
        return (
          <GeographyManagement
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      case 'fieldManagement':
        return (
          <FieldManagement
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      case 'organizerManagement':
        return (
          <OrganizerManagement
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      case 'materialManagement':
        return (
          <MaterialManagement
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      case 'importHistory':
        return (
          <ImportHistory
            {...navigationState.props}
            onNavigate={handleNavigation}
            onBack={handleBackNavigation}
          />
        );
      default:
        return null;
    }
  };
  const handleBottomSheetOpen = (value: boolean) => {
    setShowFilterBottomSheet(value);
  };

  return (
    <>
      {isMobileView ? (
        <>
          <AppBar
            ref={headerRef}
            position={isSticky ? 'fixed' : 'static'}
            className="app-bar-container"
            style={{
              top: isSticky ? 0 : '',
            }}
            onClick={() =>
              handleBottomSheetOpen(
                showFilterBottomSheet == true ? false : true
              )
            }>
            <Box className="bar-text-container">
              <Box
                component={'span'}
                className="filter-icon-text">
                <FilterAltOutlined />
              </Box>
              <Box
                component={'span'}
                className="filter-icon-text">
                Filter
              </Box>
              <Box
                component={'span'}
                className="arrow-icons">
                {showFilterBottomSheet ? (
                  <ArrowDropUp />
                ) : (
                  <ArrowDropDown />
                )}
              </Box>
            </Box>
          </AppBar>
          <Drawer
            anchor="bottom"
            open={showFilterBottomSheet}
            onClose={() => handleBottomSheetOpen(false)}
            PaperProps={{
              sx: {
                borderRadius: '16px 16px 0 0',
                padding: 2,
              }, // Customize appearance
            }}>
            <Box sx={{ height: '80vh' }}>
              <MVPFilters
                filterValues={commonFilters}
                // filtersIsCollapsed={filtersIsCollapsed}
                handleApplyFilter={handleApplyFilter}
              />
            </Box>
          </Drawer>
        </>
      ) : (
        <>
          {filtersIsCollapsed == false && (
            <Box sx={{ display: 'flex' }}>
              <MVPAppHeader />

              <Drawer
                variant="permanent"
                sx={{
                  width: 60,
                  flexShrink: 0,
                  '& .MuiDrawer-paper': {
                    width: 60,
                    boxSizing: 'border-box',
                    alignItems: 'center',
                    // pt: 2,
                    marginTop: 7.5,
                    backgroundColor: '#fff',
                    borderRight: '1px solid #eee',
                  },
                }}>
                <List
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                  }}>
                  {visibleMenuItems.map((item) => {
                    const isActive =
                      navigationState.tabId === item.id;
                    const IconComponent = item.icon;
                    return (
                      <ListItem
                        button
                        key={item.id}
                        onClick={() =>
                          handleNavigation(item.id)
                        }
                        sx={{
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px', // 🔹 Reduce spacing between icon & text
                          padding: '4px 10px',
                          whiteSpace: 'nowrap', // 🔹 Prevents text from wrapping
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}>
                        <ListItemIcon
                          sx={{
                            minWidth: 'auto',
                            color: isActive
                              ? 'rgba(2, 105, 93, 1)'
                              : 'rgba(0, 0, 0, 0.9)',
                            backgroundColor: isActive
                              ? 'rgba(0, 105, 112, 0.15)'
                              : 'transparent',
                            transition: 'all 0.3s ease',
                            borderRadius: '6px',
                            padding: '4px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            '&:hover': {
                              backgroundColor:
                                'rgba(0, 105, 112, 0.15)',
                            },
                          }}>
                          <IconComponent
                            width={30}
                            height={30}
                            style={{
                              fill: isActive
                                ? 'rgba(2, 105, 93, 1)'
                                : '',

                              transition: '0.3s ease',
                            }}
                          />
                        </ListItemIcon>
                        <Typography
                          // variant="caption"
                          sx={{
                            //  mt: 0.5,
                            fontSize: 11,
                            textAlign: 'center',
                            color: isActive
                              ? 'rgba(2, 105, 93, 1)'
                              : 'rgba(0, 0, 0, 0.9)',
                            fontWeight: isActive
                              ? 600
                              : 500,
                            whiteSpace: 'nowrap',
                          }}>
                          {item.label}
                        </Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </Drawer>

              {/* Main content */}
              <Box
                component="main"
                sx={{
                  backgroundColor: '#ececec',
                  flexGrow: 1,
                  width: '80%',
                }}>
                <Box>{renderContent()}</Box>
              </Box>
            </Box>
          )}
        </>
      )}
    </>
  );
};
